import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from '@headless-shell/store';
import AppShell from 'src/AppShell';
import { CONFIG } from 'src/utils/config';
import './index.css';

const createReactContainer = () => {
  let container = document.getElementById('react-auth-wrapper');

  if (!container) {
    container = document.createElement('div');
    container.id = 'react-auth-wrapper';

    const spaContainer = document.getElementById('single-spa-application-container');
    const parent = spaContainer?.parentElement || document.body;

    if (spaContainer) {
      parent.insertBefore(container, spaContainer);
    } else {
      parent.appendChild(container);
    }
  }

  return container;
};

const showError = (error) => {
  console.error('Failed to start React auth wrapper:', error);

  const container = document.getElementById('single-spa-application-container');
  if (container) {
    container.innerHTML = `
      <div style="padding: 2rem; text-align: center; color: #dc3545;">
        <h2>Error Starting Application</h2>
        <p>Failed to start the authentication system.</p>
        <button onclick="window.location.reload()">Reload Page</button>
      </div>
    `;
  }
};

// Initialize application
try {
  const container = createReactContainer();
  const root = ReactDOM.createRoot(container);

  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <AppShell />
      </Provider>
    </React.StrictMode>
  );
} catch (error) {
  showError(error);
}
